<template>
  <TableCommon
    title="银行信息"
    :custome-config="() => vxeShowCustom('xTable3')"
  >
    <template #button>
      <table-button name="add" tip="新增" @click="insertBank" />
      <table-button name="delete" tip="删除" @click="removeBank" />
    </template>
    <vxe-grid
      ref="xTable3"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      max-height="500"
      align="center"
      size="mini"
      :empty-render="{name: 'NotData'}"
      :toolbar-config="{ custom: true, size: 'mini' }"
      :row-config="{ isCurrent: true }"
      :checkbox-config="{ highlight: true }"
      :columns="gridOptions.columns"
      :data="gridOptions.data"
    >
      <template #accountType="{ row }">
        <el-input v-model="row.accountType" size="mini" placeholder="请输入账户类型" />
      </template>
      <template #ZZFLD000022="{ row }">
        <el-input v-model="row.ZZFLD000022" size="mini" placeholder="请输入银行名称" />
      </template>
      <template #ZZFLD000023="{ row }">
        <el-input v-model="row.ZZFLD000023" size="mini" placeholder="请输入银行账号" />
      </template>
      <template #ZZFLD00009J="{ row }">
        <el-input v-model="row.ZZFLD00009J" size="mini" placeholder="请输入协议编号" />
      </template>
      <template #ZZFLD00009L="{ row }">
        <el-input v-model="row.ZZFLD00009L" size="mini" placeholder="请输入联系人" />
      </template>
      <template #ZZFLD00009M="{ row }">
        <el-input v-model="row.ZZFLD00009M" size="mini" placeholder="请输入电话" />
      </template>
      <template #ZZFLD00009R="{ row }">
        <el-input v-model="row.ZZFLD00009R" size="mini" placeholder="请输入可开具发票类型" />
      </template>
    </vxe-grid>
  </TableCommon>
</template>

<script>
export default {
  props: {
    bank: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { title: '账户类型', field: 'accountType', minWidth: 200, slots: { default: 'accountType' } },
          { title: '银行名称', field: 'ZZFLD000022', minWidth: 200, slots: { default: 'ZZFLD000022' } },
          { title: '银行账号', field: 'ZZFLD000023', minWidth: 200, slots: { default: 'ZZFLD000023' } },
          { title: '协议编号', field: 'ZZFLD00009J', minWidth: 200, slots: { default: 'ZZFLD00009J' } },
          { title: '联系人', field: 'ZZFLD00009L', minWidth: 200, slots: { default: 'ZZFLD00009L' } },
          { title: '电话', field: 'ZZFLD00009M', minWidth: 200, slots: { default: 'ZZFLD00009M' } },
          { title: '可开具发票类型', field: 'ZZFLD00009R', minWidth: 200, slots: { default: 'ZZFLD00009R' } }
        ],
        data: []
      }
    }
  },
  created() {
    this.gridOptions.data = this.bank || []
  },
  watch: {
    bank: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$set(this.gridOptions, 'data', val || [])
      }
    }
  },
  methods: {
    insertBank() {
      const newRow = {
        accountType: '',
        ZZFLD000022: '',
        ZZFLD000023: '',
        ZZFLD00009J: '',
        ZZFLD00009L: '',
        ZZFLD00009M: '',
        ZZFLD00009R: ''
      }
      this.gridOptions.data.unshift(newRow)
      this.$emit('update:bank', this.gridOptions.data)
    },
    removeBank() {
      const $table = this.$refs.xTable3
      if (!$table) return
      const checked = $table.getCheckboxRecords()
      if (!checked.length) {
        this.$message.warning('请选择要删除的银行信息')
        return
      }
      checked.forEach(row => {
        const index = this.gridOptions.data.indexOf(row)
        if (index !== -1) {
          this.gridOptions.data.splice(index, 1)
        }
      })
      this.$emit('update:bank', this.gridOptions.data)
    },
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/client-manage/components/BankInfoAdd.vue